/**
 * 客户端
 */
import React from 'react';
import styles from './index.module.scss';
import { XOKButton, XCancelButton, XInput, } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { message, } from 'antd';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import model from '@/reducers/contract/contractlist/model';
import UpdateModal from './modal/UpdateModal';


class Knight extends React.PureComponent {

    state = {
        agreementName: '',//协议名称
        versionNum: '',//协议编号
        currentOpenMode: '', // 当前需要打开的弹窗
        openModeParam: {}, // 当前需要打开的弹窗的入参
    }

    componentDidMount() {
      
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, versionNum, agreementName, } = this.state;
        const { getContractList, } = this.props;
        this.searchCache = {
            appType: 'RIDER_APP',//USER_APP-用户;RIDER_APP-骑士;
            contractName: agreementName,//协议名称
            contractCode: versionNum,//协议编号
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        getContractList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置触发
    _resetHandle = () => {
        this.setState({ agreementName: '', versionNum: '', }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }
    // 页面发生变化
    _paginationChange = (pageSize, pageNum) => {
        this.searchCache = { ...this.searchCache, pageSize, pageNum };
        this.props.getContractList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageSize, pageNum }); // 【第5步：缓存分页状态】
    }
    // 表格操作  
    _tableAction = (item, type, value) => {
        const { history, curTabID } = this.props;
        switch (type) {
            case 'ment'://管理
                history.push({
                    pathname: '/home/contract/contractlist/contractlistment/' + item,
                    search: `titleName=骑士端 - ${value.contractName}&tabId=${curTabID}`,
                });
                break;
            case 'name'://协议名称
                this.setState({
                    currentOpenMode: 'name',
                    openModeParam: item,
                });
                break;
        }
    }


    // 打开弹窗  
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case 'name'://协议名称
                return <UpdateModal title='修改协议名称' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    // 关闭弹框
    _closeMode = (status) => {
        this.setState({ currentOpenMode: '' });
        if (status) {
            this.props.getContractList(this.searchCache);
        }
    }


    render() {
        const { versionNum, agreementName, } = this.state;
        const { contractList } = this.props;
        return (

            <KeepAlive id='2' render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                label='协议名称'
                                placeholder='请输入协议名称'
                                value={agreementName}
                                bindThis={this}
                                bindName='agreementName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                label='协议编号'
                                placeholder='请输入协议编号'
                                value={versionNum}
                                bindThis={this}
                                bindName='versionNum'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableContent
                        renderData={contractList}
                        tableAction={this._tableAction}
                        paginationChange={this._paginationChange}
                    />
                    {this._renderMode()}
                </div>
            </KeepAlive>
        );
    }
}

Knight.propTypes = {
    history: PropTypes.object, // 路由history对象
    contractList: PropTypes.object, // 客户端、骑士端列表
    getContractList: PropTypes.func, // 客户端、骑士端列表数据action
    curTabID: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),//显示的tab
};

const mapStateToProps = (state) => {
    return {
        contractList: state.contractlist.contrList,
    };
};
export default connect(mapStateToProps, model.actions)(Knight);